"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IEnvDomain = exports.IEnv = exports.ICountryDomain = exports.ICountry = exports.ErrorCode = exports.ContentTypeHeader = exports.FileExt = exports.MediaType = exports.ContentType = exports.HttpCode = exports.UploaderEvents = void 0;
var UploaderEvents;
(function (UploaderEvents) {
    UploaderEvents["mediaUpload"] = "media_upload";
    UploaderEvents["mediaProgress"] = "media_progress";
    UploaderEvents["coverUpload"] = "cover_upload";
    UploaderEvents["coverProgress"] = "cover_progress";
    UploaderEvents["imageProgress"] = "image_progress";
    UploaderEvents["imageUpload"] = "image_upload";
})(UploaderEvents = exports.UploaderEvents || (exports.UploaderEvents = {}));
var HttpCode;
(function (HttpCode) {
    HttpCode[HttpCode["ok"] = 200] = "ok";
    HttpCode[HttpCode["invalidParam"] = 400] = "invalidParam";
    HttpCode[HttpCode["invalidToken"] = 403] = "invalidToken";
    HttpCode[HttpCode["bucketUnExist"] = 404] = "bucketUnExist";
    HttpCode[HttpCode["sizeExceeded"] = 413] = "sizeExceeded";
    HttpCode[HttpCode["serverError"] = 500] = "serverError";
})(HttpCode = exports.HttpCode || (exports.HttpCode = {}));
var ContentType;
(function (ContentType) {
    ContentType["video"] = "video";
    ContentType["image"] = "image";
    ContentType["audio"] = "audio";
})(ContentType = exports.ContentType || (exports.ContentType = {}));
var MediaType;
(function (MediaType) {
    MediaType["video"] = "video";
    MediaType["audio"] = "audio";
})(MediaType = exports.MediaType || (exports.MediaType = {}));
var FileExt;
(function (FileExt) {
    FileExt["video"] = "mp4";
    FileExt["image"] = "jpg";
    FileExt["audio"] = "aac";
})(FileExt = exports.FileExt || (exports.FileExt = {}));
var ContentTypeHeader;
(function (ContentTypeHeader) {
    ContentTypeHeader["video"] = "video/mp4";
    ContentTypeHeader["image"] = "image/jpeg";
    ContentTypeHeader["audio"] = "audio/aac";
    ContentTypeHeader["slice"] = "application/octet-stream";
    ContentTypeHeader["pngImage"] = "image/png";
})(ContentTypeHeader = exports.ContentTypeHeader || (exports.ContentTypeHeader = {}));
var ErrorCode;
(function (ErrorCode) {
    ErrorCode[ErrorCode["Success"] = 0] = "Success";
    ErrorCode[ErrorCode["Unknown"] = -1] = "Unknown";
    ErrorCode[ErrorCode["PreparePublishFail"] = 1000] = "PreparePublishFail";
    ErrorCode[ErrorCode["PublishResultRequestFailed"] = 1001] = "PublishResultRequestFailed";
    ErrorCode[ErrorCode["PublishResultResponseError"] = 1002] = "PublishResultResponseError";
    ErrorCode[ErrorCode["PublishResultVideoFailed"] = 1003] = "PublishResultVideoFailed";
    ErrorCode[ErrorCode["PublishResultCoverFailed"] = 1004] = "PublishResultCoverFailed";
    ErrorCode[ErrorCode["PublishResultVideoInvalid"] = 1007] = "PublishResultVideoInvalid";
    ErrorCode[ErrorCode["PublishResultCoverInvalid"] = 1008] = "PublishResultCoverInvalid";
    ErrorCode[ErrorCode["TokenInvalid"] = 1012] = "TokenInvalid";
    ErrorCode[ErrorCode["VideoPathIsNull"] = 1013] = "VideoPathIsNull";
    ErrorCode[ErrorCode["VideoNoExist"] = 1014] = "VideoNoExist";
    ErrorCode[ErrorCode["CoverNoExist"] = 1016] = "CoverNoExist";
    ErrorCode[ErrorCode["UserCancel"] = 1017] = "UserCancel";
    ErrorCode[ErrorCode["CheckFileFail"] = 1101] = "CheckFileFail";
    ErrorCode[ErrorCode["UssMergeFilesFail"] = 1102] = "UssMergeFilesFail";
})(ErrorCode = exports.ErrorCode || (exports.ErrorCode = {}));
var ICountry;
(function (ICountry) {
    ICountry["SG"] = "SG";
    ICountry["MY"] = "MY";
    ICountry["BR"] = "BR";
    ICountry["ID"] = "ID";
    ICountry["TW"] = "TW";
    ICountry["VN"] = "VN";
    ICountry["TH"] = "TH";
    ICountry["PH"] = "PH";
    ICountry["MX"] = "MX";
    ICountry["CO"] = "CO";
    ICountry["CL"] = "CL";
    ICountry["AR"] = "AR";
    ICountry["PL"] = "PL";
    ICountry["ES"] = "ES";
    ICountry["FR"] = "FR";
    ICountry["IN"] = "IN";
})(ICountry = exports.ICountry || (exports.ICountry = {}));
var ICountryDomain;
(function (ICountryDomain) {
    ICountryDomain["SG"] = "sg";
    ICountryDomain["MY"] = "com.my";
    ICountryDomain["BR"] = "com.br";
    ICountryDomain["ID"] = "co.id";
    ICountryDomain["TW"] = "tw";
    ICountryDomain["VN"] = "vn";
    ICountryDomain["TH"] = "co.th";
    ICountryDomain["PH"] = "ph";
    ICountryDomain["MX"] = "com.mx";
    ICountryDomain["CO"] = "com.co";
    ICountryDomain["CL"] = "cl";
    ICountryDomain["AR"] = "com.ar";
    ICountryDomain["PL"] = "pl";
    ICountryDomain["ES"] = "es";
    ICountryDomain["FR"] = "fr";
    ICountryDomain["IN"] = "in";
})(ICountryDomain = exports.ICountryDomain || (exports.ICountryDomain = {}));
var IEnv;
(function (IEnv) {
    IEnv["TEST"] = "test";
    IEnv["LIVE"] = "live";
    IEnv["UAT"] = "uat";
    IEnv["STAGING"] = "staging";
})(IEnv = exports.IEnv || (exports.IEnv = {}));
var IEnvDomain;
(function (IEnvDomain) {
    IEnvDomain["live"] = "";
    IEnvDomain["staging"] = "staging.";
    IEnvDomain["uat"] = "uat.";
    IEnvDomain["test"] = "test.";
})(IEnvDomain = exports.IEnvDomain || (exports.IEnvDomain = {}));
